import styled from 'styled-components';

import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAISecond/components/Title';

export const UsersReviewsStyles = styled.section`
  margin: 32px 0;
  padding: 0 16px;

  .store-images {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 16px 0 24px;

    img {
      width: 104px;
      height: auto;
      aspect-ratio: 1 / 0.29;
    }
  }
`;

export const UsersReviewsTitleStyles = styled(OwnAiTitle)`
  margin: 20px 0;
`;

export const UsersReviewsWrapperStyles = styled.section`
  width: 100%;
  max-width: 540px;
  margin: 20px auto 0;
`;
